import React from 'react';

const signatureDishes = ['Charcoal Grilled Chicken', 'T-Bone Steak', 'Lobster Thermidor'];

const MeetChef = () => (
  <section className="section-padding" style={{ backgroundColor: '#ffffff' }}>
    <div className="container">
      <div className="row align-items-center g-5">
        <div className="col-lg-5 reveal-left">
          <div style={{ borderRadius: '16px', overflow: 'hidden', boxShadow: '0 8px 30px rgba(0,0,0,0.12)' }}>
            <img
              src="https://images.unsplash.com/photo-1583394293214-28ded15ee548?w=600&q=80"
              alt="Head Chef at Syra Food Point"
              style={{ width: '100%', height: '400px', objectFit: 'cover' }}
              loading="lazy"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = 'https://images.unsplash.com/photo-1577219491135-ce391730fb2c?w=600&q=80';
              }}
            />
          </div>
        </div>
        <div className="col-lg-7 reveal-right">
          <span className="section-subtitle">The Artisan</span>
          <h2 style={{ fontFamily: 'Playfair Display, serif', fontSize: '2.5rem', fontWeight: 600, marginBottom: '24px' }}>
            Meet Our Head Chef
          </h2>
          {/* Lead with quote */}
          <p className="chef-quote mb-4">
            "For me, every meal should remind you of home."
          </p>
          <p style={{ fontSize: '1rem', color: '#666', lineHeight: 1.9, marginBottom: '24px' }}>
            With over 15 years of culinary mastery across East Africa's finest kitchens, our head chef brings a unique blend of traditional Ugandan flavors and contemporary techniques. Every dish that leaves our kitchen carries a stamp of excellence.
          </p>
          {/* Signature dishes */}
          <div className="mb-4">
            <h6 style={{ fontSize: '0.8rem', textTransform: 'uppercase', letterSpacing: 2, color: '#999', marginBottom: '12px' }}>
              Signature Dishes
            </h6>
            {signatureDishes.map((dish, i) => (
              <div key={i} className="d-flex align-items-center gap-2 mb-2">
                <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#D4AF37', flexShrink: 0 }}></span>
                <span style={{ fontSize: '0.95rem', fontWeight: 500 }}>{dish}</span>
              </div>
            ))}
          </div>
          <p style={{ fontSize: '0.85rem', color: '#999' }}>15+ Years of Culinary Excellence</p>
        </div>
      </div>
    </div>
  </section>
);

export default MeetChef;
